const state = () => ({
  defaultLang: {
    id: 'en',
    name: 'English',
    icon: '/langs/en.svg'
  },
  langs: [
    {
      id: 'ru',
      name: 'Russian',
      icon: '/langs/ru.svg'
    },
    {
      id: 'en',
      name: 'English',
      icon: '/langs/en.svg'
    },
    {
      id: 'tr',
      name: 'Turkish',
      icon: '/langs/tr.svg'
    },
    {
      id: 'es',
      name: 'Spanish',
      icon: '/langs/es.svg'
    },
    {
      id: 'id',
      name: 'Indonesian',
      icon: '/langs/in.svg'
    },
    {
      id: 'pt',
      name: 'Portuguese',
      icon: '/langs/pt.svg'
    }
  ],
})
  
  export default {
    namespaced: true,
    state
  };
